import { EVENT } from '@tdtk/types';

const { EVENT_TYPES, AP_MUSIC_THEORY_ASMT_ID } = EVENT;
type EventTypeValue = (typeof EVENT_TYPES)[keyof typeof EVENT_TYPES];

export const IN_SCHOOL_EVENTS = [
  EVENT_TYPES.INSCHOOL_AP,
  EVENT_TYPES.INSCHOOL_APHYBRID,
  EVENT_TYPES.INSCHOOL_PSAT10,
  EVENT_TYPES.INSCHOOL_PSATNM,
  EVENT_TYPES.INSCHOOL_PSAT89,
  EVENT_TYPES.INSCHOOL_SAT,
];

export const IN_SCHOOL_PSAT_EVENTS = [
  EVENT_TYPES.INSCHOOL_PSAT10,
  EVENT_TYPES.INSCHOOL_PSATNM,
  EVENT_TYPES.INSCHOOL_PSAT89,
];

export const IN_SCHOOL_PSAT_SAT_EVENTS = [
  EVENT_TYPES.INSCHOOL_PSAT10,
  EVENT_TYPES.INSCHOOL_PSATNM,
  EVENT_TYPES.INSCHOOL_PSAT89,
  EVENT_TYPES.INSCHOOL_SAT,
];

export const IN_SCHOOL_AP_EVENTS = [EVENT_TYPES.INSCHOOL_AP, EVENT_TYPES.INSCHOOL_APHYBRID];

export const WEEKEND_EVENTS = [EVENT_TYPES.WEEKEND_SAT, EVENT_TYPES.WEEKENDATSCHOOL_SAT];

export const MONITOR_NO_ACCESS_EVENTS = [...WEEKEND_EVENTS];

export function isMonitorNoAccessSupported(tdtkAsmtType: string) {
  return (MONITOR_NO_ACCESS_EVENTS as string[]).includes(tdtkAsmtType);
}

export const NO_DISPLAY_DATE_EVENTS = [
  EVENT_TYPES.INSCHOOL_PSAT10,
  EVENT_TYPES.INSCHOOL_PSAT89,
  EVENT_TYPES.INSCHOOL_SAT,
];

type EventPayload = {
  tdtkAsmtType: EventTypeValue;
  asmtId?: string;
};

export function isInSchoolEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false; // handle null or empty tdtkAsmtType: default to non-in-school event
  } else {
    return IN_SCHOOL_EVENTS.includes(event?.tdtkAsmtType);
  }
}

export function isInSchoolPSATEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false; // handle null or empty tdtkAsmtType
  } else {
    return IN_SCHOOL_PSAT_EVENTS.includes(event?.tdtkAsmtType);
  }
}
export function isInSchoolPSATNMEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false; // handle null or empty tdtkAsmtType
  } else {
    return event?.tdtkAsmtType === EVENT_TYPES.INSCHOOL_PSATNM;
  }
}

export function isInSchoolPSATSATEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false; // handle null or empty tdtkAsmtType
  } else {
    return IN_SCHOOL_PSAT_SAT_EVENTS.includes(event?.tdtkAsmtType);
  }
}

export function isWeekendEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false; // handle null or empty tdtkAsmtType: default to non-in-school event
  } else {
    return WEEKEND_EVENTS.includes(event?.tdtkAsmtType);
  }
}

export function isInSchoolSATEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false;
  } else {
    return event?.tdtkAsmtType === EVENT_TYPES.INSCHOOL_SAT;
  }
}

export function isInSchoolAPEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false;
  } else {
    return event?.tdtkAsmtType === EVENT_TYPES.INSCHOOL_AP;
  }
}

export function isInSchoolAPHybridEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false;
  } else {
    return event?.tdtkAsmtType === EVENT_TYPES.INSCHOOL_APHYBRID;
  }
}

export function isInSchoolAPEvents(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false;
  } else {
    return IN_SCHOOL_AP_EVENTS.includes(event?.tdtkAsmtType);
  }
}

export function isWeekendAtSchoolSATEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false;
  } else {
    return event?.tdtkAsmtType === EVENT_TYPES.WEEKENDATSCHOOL_SAT;
  }
}

export function isWeekendSATEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false;
  } else {
    return event?.tdtkAsmtType === EVENT_TYPES.WEEKEND_SAT;
  }
}

export function isInSchoolAPMTEvent(event: EventPayload) {
  return isInSchoolAPHybridEvent(event) && event?.asmtId === AP_MUSIC_THEORY_ASMT_ID;
}

export function isNoDisplayDateEvent(event: EventPayload) {
  if (!event?.tdtkAsmtType) {
    return false; // handle null or empty tdtkAsmtType: default to non-in-school event
  } else {
    return NO_DISPLAY_DATE_EVENTS.includes(event?.tdtkAsmtType);
  }
}
